module.exports = __webpack_public_path__ + "static/media/dermatology.2911f45d.svg";